import React from 'react';
import classes from './SidebarPromoCards.module.scss';
import { isPromoBlackout } from '../../pages/TVP/promoBlackout';

const cards = [
  {
    key: 'zagraniczne',
    title: 'Podróże zagraniczne',
    description: 'Bezpieczne wakacje z telekonsultacją za granicą',
    image: 20,
    detailsHref: 'https://tvp.uspartner.pl/zagraniczne/opis/'
  },
  {
    key: 'assistance',
    title: 'Moto Assistance',
    description: 'Pomoc na drodze 24/7 - nie martw się awarią',
    image: 21,
    detailsHref: 'https://tvp.uspartner.pl/assistance/opis/'
  },
  {
    key: 'pethelp',
    title: 'Pethelp',
    description: 'Pakiety weterynaryjne dla psa i\u00A0kota',
    image: 81,
    detailsHref: 'https://tvp.uspartner.pl/pethelp/opis/'
  }
];

const SidebarPromoCards = () =>
  isPromoBlackout() ? null : (
    <div className={classes.wrapper}>
      {cards
        .filter((card) => !card.hidden)
        .map((card) => (
          <article
            key={card.key}
            className={classes.card}
            style={{
              backgroundImage: `url('${process.env.PUBLIC_URL}/tvp/dashboard/${card.image}.jpg')`
            }}>
            <div className={classes.overlay} />
            <a
              aria-label={card.title}
              className={classes.cardLink}
              href={card.detailsHref}
              rel="noopener noreferrer"
              target="_blank">
              <span
                className={`${classes.title} ${
                  card.key === 'zagraniczne' ? classes.titleWide : ''
                }`}>
                {card.title}
              </span>
              <div className={classes.content}>
                <span className={classes.description}>{card.description}</span>
                <span className={classes.cta}>Sprawdź ofertę</span>
              </div>
            </a>
          </article>
        ))}
    </div>
  );

export default SidebarPromoCards;
